import { useTranslation } from 'react-i18next';

import './step.scss';
export const NavWizard = (props: any) => {
  const { t } = useTranslation();
  return (
    <>
      <ol className="progtrckr">{props.children({ ...props, children: undefined })}</ol>
    </>
  );
};
